module.exports = __webpack_public_path__ + "img/envelope_icon.f12d66bb.svg";